import React from "react";
import { useController } from "react-hook-form";
import { CTextField } from "../StyledComponent";
import { regexNumber } from "../../utils/Constant";

function ControlledTextField({ name, number = false, regex, control, label, row = 1, inputStyle = {}, ...props }) {
  const { field, formState: { errors } } = useController({ name, control });
  const _onChange = (event) => {
    const val = event.target.value;
    if (number && !regexNumber.test(val) && val !== "") return;
    if (regex && !regex?.test(val) && val !== "") return;
    field.onChange(val);
  };

  return (
    <CTextField
      {...props}
      label={label}
      value={field?.value ?? ""}
      onChange={_onChange}
      error={errors[name] !== undefined}
      helperText={errors[name]?.message ?? ""}
      sx={{ width: "100%", ...props.sx }}
      maxRows={row}
      minRows={row}
      multiline={row !== 1}
      InputProps={{ readOnly: props.readOnly ?? false, ...props.InputProps }}
      inputProps={{
        className: 'scroll_container',
        onFocus: (e) => ["true"].includes(props.focus) ? e.target.select() : null,
        sx: { padding: '0', ...inputStyle },
        ...props.inputProps
      }}
    />
  );
}

export default ControlledTextField;
